import React, { memo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18n from 'i18next';

import { getPrizeInfoAPI } from 'api/client';
import { prizeTypes } from 'config/promoPrizeTypes';
import { clearParticipantWinnerPopup } from 'client/redux/modules/flags';
import useClientHistory, { PRIZE } from 'client/hooks/useClientHistory';
import PopupWinnerGet from 'client/components/Prize/PopupWinnerGet';

function PopupParticipantJoinAndGetPrize() {
    const dispatch = useDispatch();
    const history = useClientHistory();
    const promoUUID = useSelector(s => s.promo.uuid);
    const {
        participantPrizePopup: { prizeUUID, entryUUID }
    } = useSelector(s => s.flags);
    const [prizeInfo, setPrizeInfo] = useState({});
    const [hasWinner, setHasWinner] = useState(false);

    const isThanksPrize = prizeInfo.type === prizeTypes.THANKYOU;

    useEffect(() => {
        (async () => {
            if (prizeUUID) {
                try {
                    const { payload: prizeData } = await getPrizeInfoAPI(promoUUID, prizeUUID);
                    const {
                        prize: { name, type, uuid } = {},
                        prizeSetting: { imageUrl } = {}
                    } = prizeData;

                    setPrizeInfo({
                        name,
                        type,
                        imageUrl,
                        uuid
                    });
                    setHasWinner(true);
                } catch (error) {
                    console.log(error);
                }
            }
        })();
    }, [promoUUID, prizeUUID]);

    return (
        <PopupWinnerGet
            isOpen={hasWinner}
            title={
                isThanksPrize ? i18n.t('label.keep_up_the_work') : i18n.t('label.congratulation')
            }
            label={prizeInfo.name}
            imgSrc={prizeInfo.imageUrl}
            onConfirm={() => {
                dispatch(clearParticipantWinnerPopup());
                if (isThanksPrize) {
                    setHasWinner(false);
                } else {
                    history.replace(PRIZE, {
                        prizeUUID: prizeInfo.uuid,
                        entriesUUID: entryUUID
                    });
                }
            }}
            btnText={isThanksPrize ? i18n.t('btn.close') : i18n.t('button.receive_prize')}
        />
    );
}

export default memo(PopupParticipantJoinAndGetPrize);
